import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Simulation } from '@helpers/types/models';

@Component({
	selector: 'app-simulation-status',
	standalone: false,
	templateUrl: './simulation-status.component.html',
	styleUrl: './simulation-status.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimulationStatusComponent {
	@Input() task!: Simulation;
}
